import React from 'react'
import { GETConceptsResponseRow, IConceptParticipants } from '@cbgms/api/modules/concepts'
import SupportListWrapper from 'core/page/SupportListWrapper'
import N from 'utils-support/navigation'
import { getConceptParticipants, listConcepts } from '../state/actions'
import { TooltipButton } from '@cbgms/components/form/TooltipButton'
import { useTranslation } from 'react-i18next'
import { useNotifier } from '@cbgms/base/notifier'
import { useDispatch } from 'react-redux'
import { useBlobDownloader } from '@cbgms/base/hooks/use-blob-downloader'
import { fields } from '@cbgms/components/list'
import { ListRow } from 'core/types/ListRow'

const ConceptsList: React.FC = () => {
  const { t } = useTranslation()
  const notifier = useNotifier()
  const dispatch = useDispatch()
  const download = useBlobDownloader()

  const onAdd = () => {
    N.push('/concepts/new')
  }

  const onEdit = (data: GETConceptsResponseRow) => {
    N.push(`/concepts/edit/${data.Concept.UUID}`)
  }

  const onExport = async (row: ListRow<GETConceptsResponseRow>) => {
    try {
      const conceptUUID = row?.data?.Concept.UUID
      const conceptName = row?.data?.Concept.Name
      const blob = await dispatch(
        getConceptParticipants(conceptUUID, {
          format: 'csv',
          fields: fields<IConceptParticipants>()
            .add(o => o.Shop.ID)
            .add(o => o.Company.Name)
            .add(o => o.Shop.Name)
            .add(o => o.Shop.PhoneNumber)
            .add(o => o.Shop.EmailAddress)
            .add(o => o.Shop.VisitorCity)
            .add(o => o.Shop.CreatedAt)
            .add(o => o.Shop.UpdatedAt)
            .add(o => o.ShopDefaultOrderAccount.FullName)
            .add(o => o.ShopDefaultOrderAccount.ExternalID)
            .toString(),
          perPage: Number.MAX_SAFE_INTEGER
        })
      )

      download(blob as any as Blob, `${conceptName}_participants`)
      notifier.success(t('global.successfully_exported'))
    } catch {
      notifier.error(t('global.something_went_wrong'))
    }
  }

  const actions = (row: ListRow<GETConceptsResponseRow>) => (
    <TooltipButton title={t('global.export_concept_participants')} icon='share square' onClick={() => onExport(row)} />
  )

  return (
    <SupportListWrapper
      scope='concepts'
      type='list'
      onAdd={onAdd}
      onEdit={onEdit}
      actions={actions}
      skipDryRun
      loadAction={listConcepts}
      translationKey='concepts'
    />
  )
}

export default ConceptsList
